import { Button } from '@material-tailwind/react';
import * as XLSX from 'xlsx';

const ExportToExcelLibroFET = ({ data, fileName }) => {

  const exportToExcel = () => {
    let dataExcel = [];

     data.map(item => {
        let newData = {
          Fecha:  item.fecha,
          ["Aportante/Proveedor"]: item.aportante_proveedor,
          Descripción: item.descripcion,
          // ["Saldo Acumulado"]: item.saldo_acum,
          Debe: item.debe,
          Haber: item.haber,
          ["Saldo Total"]: item.saldo_total,
          Cbu: item.cbu,
        }
        dataExcel.push(newData);
      })
 
    // Crear la hoja de cálculo desde un arreglo de datos
    const worksheet = XLSX.utils.json_to_sheet(dataExcel, { origin: 'A1' }); 
    
    // Ancho de columnas
    worksheet['!cols'] = [
      { wch: 30 },  
      { wch: 30 }, 
      { wch: 30 }, 
      // { wch: 30 }, 
      { wch: 30 }, 
      { wch: 30 }, 
      { wch: 30 }, 
      { wch: 30 }, 
      { wch: 30 }, 
      { wch: 30 }, 
      // Añade más columnas si es necesario
    ];

    // Crear un nuevo libro de trabajo
    const workbook = XLSX.utils.book_new();

    // Añadir la hoja al libro
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Descargar el archivo
    XLSX.writeFile(workbook, `${fileName}.xlsx`);
  };

  return (
    <Button variant="gradient" className="flex justify-center items-center gap-3 mb-3 lg:mb-0" onClick={exportToExcel}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className="h-4 w-4/"
            >
            <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M12 16.5V9.75m0 0l3 3m-3-3l-3 3M6.75 19.5a4.5 4.5 0 01-1.41-8.775 5.25 5.25 0 0110.233-2.33 3 3 0 013.758 3.848A3.752 3.752 0 0118 19.5H6.75z"
            />
        </svg>
      Exportar Excel
    </Button>
  );
};

export default ExportToExcelLibroFET;
